<script>
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import SLSTabelaPrecoService from '@/services/SistemaDKP/SLSTabelapreco.service';

const slsTabelapreco = new SLSTabelaPrecoService();
export default {
  name: 'ModalBuscarTabelaPreco',
  components: { BOverlay },
  data() {
    return {
      isLoading: false,
      dataAlreadyFetched: false,
      dataFetchedForCliente: {},
      filtersHeader: {
        tabelapreco_id: '',
        tabelapreco_descricao: '',
      },
      currentPage: 1,
      fields: [
        { key: 'tabelapreco_id', label: 'Código' },
        { key: 'tabelapreco_descricao', label: 'Descrição' },
        { key: 'acoes', label: 'Ações' },
      ],
    };
  },
  computed: {
    ...mapGetters('SLSTabelapreco', {
      filters: 'filters',
      tabelaPrecos: 'tabelaprecos',
    }),
    dataMetaRepresentante() {
      const total = this.filters && this.filters.total ? this.filters.total : 0;
      const from = this.filters && this.filters.from ? this.filters.from : 0;
      const to = this.filters && this.filters.to ? this.filters.to : 0;

      return `Mostrando ${from} até ${to} de ${total}`;
    },
    getTotalRows() {
      return this.filters && this.filters.total ? this.filters.total : 0;
    },
    getPerPage() {
      return this.filters && this.filters.perPage ? this.filters.perPage : 10;
    },
  },
  methods: {
    async fetchInitialData() {
      try {
        this.isLoading = true;
        const clienteIdERP = this.$store.getters['InfoPedido/GET_CLIENT_ID_ERP'].clienteiderp;
        const isCreatePedidos = this.$router.currentRoute.name === 'pedidos-vendas-create';

        if (!clienteIdERP) {
          console.warn('Cliente ID ERP não encontrado');
          return;
        }

        if (isCreatePedidos) {
          this.filtersHeader = {
            tabelapreco_id: '',
            tabelapreco_descricao: '',
          };

          this.$store.commit('SLSTabelapreco/SET_FILTERS', {
            page: 1,
            perPage: 10,
          });

          await this.getTabelaPrecoByClienteRRP();
          return;
        }

        if (this.dataAlreadyFetched && this.lastClienteIdERP === clienteIdERP
          && this.tabelaPrecos && this.tabelaPrecos.length > 0) {
          const savedFilters = this.$store.getters['SLSTabelapreco/filters'];
          this.filtersHeader.tabelapreco_id = savedFilters.tabelapreco_id || '';
          this.currentPage = savedFilters.page || 1;
          return;
        }

        this.filtersHeader = {
          tabelapreco_id: '',
          tabelapreco_descricao: '',
        };

        this.$store.commit('SLSTabelapreco/SET_FILTERS', {
          page: 1,
          perPage: 10,
        });

        await this.getTabelaPrecoByClienteRRP();
        this.dataAlreadyFetched = true;
        this.lastClienteIdERP = clienteIdERP;
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async getTabelaPrecoByClienteRRP() {
      const clienteIdERP = this.$store.getters['InfoPedido/GET_CLIENT_ID_ERP'].clienteiderp;

      if (!clienteIdERP) {
        console.warn('Cliente ID ERP não encontrado');
        return;
      }

      this.isLoading = true;
      try {
        const tabelaPreco = await slsTabelapreco.getTabelaPrecoByClienteIdERP(
          clienteIdERP,
          { ...this.$store.getters['SLSTabelapreco/filters'], ...this.filtersHeader },
        );

        console.log('Tabelas de preço encontradas:', tabelaPreco);

        const tabelasPreco = Array.isArray(tabelaPreco) ? tabelaPreco : [];

        this.$store.commit('SLSTabelapreco/SET_TABELAPRECOS', tabelasPreco);
        this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', tabelasPreco);

        if (tabelasPreco.length === 0) {
          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
            ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
            tabelaprecoid: '',
            tabelapreco_descricao: '',
          });

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Aviso',
              text: 'Nenhuma tabela de preço encontrada para este cliente',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
            },
          });
        }
      } catch (error) {
        console.error('Erro ao buscar tabelas de preço:', error);
        this.$store.commit('SLSTabelapreco/SET_TABELAPRECOS', []);
        this.$store.commit('InfoPedido/SET_OPTIONS_TABELA_PRECO', []);

        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
          ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
          tabelaprecoid: '',
          tabelapreco_descricao: '',
        });
      } finally {
        this.isLoading = false;
      }
    },
    async info(item, index, target) {
      this.$store.commit('InfoPedido/SET_TABELA_PRECO', item);
      this.$store.commit('SLSTabelapreco/SET_TABELAPRECOS', item);

      const currentRoute = this.$router.currentRoute.name;

      if (currentRoute === 'pedidos-vendas-create') {
        const formData = this.$store.getters['intensPedido/getFormData'];

        if (formData && formData.dataCapaPedido) {
          formData.dataCapaPedido.tabelaprecoid = item.tabelapreco_id;
          formData.dataCapaPedido.tabelapreco_descricao = item.tabelapreco_descricao;

          this.$store.commit('intensPedido/SET_CAPA_PEDIDO', formData.dataCapaPedido);
        }
      }

      this.$refs.modalBuscarTabelapreco.hide();

      // Emitir evento global para que detalhesPedidoVenda possa reagir
      this.$root.$emit('tabelapreco:selected', {
        tabelapreco_id: item.tabelapreco_id,
        tabelapreco_descricao: item.tabelapreco_descricao,
      });

      const infoFormData = this.$store.getters['InfoPedido/GET_FORM_INFO_PEDIDO'];
      if (infoFormData && infoFormData.cliente?.clienteid) {
        this.$store.commit('PicStore/SET_FILTERS', {
          clienteid: infoFormData.cliente.clienteid,
          estabelecimentoid: infoFormData.estabelecimento?.estabelecimentoid,
          tabelaprecoId: item.tabelapreco_id,
          condicaopagamentoid: infoFormData.condicaoPagamento?.condicaopagamentoid,
        });
      }

      const dadosCliente = this.$store.getters['intensPedido/getFormData'];
      if (dadosCliente && dadosCliente.enderecoEntrega?.clienteid) {
        const filtrosPic = {};

        if (dadosCliente.enderecoEntrega.clienteid) filtrosPic.clienteid = dadosCliente.enderecoEntrega.clienteid;
        if (dadosCliente.dataCapaPedido.estabelecimentoid) filtrosPic.estabelecimentoid = dadosCliente.dataCapaPedido.estabelecimentoid;
        if (item.tabelapreco_id) filtrosPic.tabelaprecoId = item.tabelapreco_id;
        if (dadosCliente.dataCapaPedido.condicaopagamentoid) filtrosPic.condicaopagamentoid = dadosCliente.dataCapaPedido.condicaopagamentoid;

        if (Object.keys(filtrosPic).length > 0) {
          this.$store.commit('PicStore/SET_FILTERS', filtrosPic);
          this.$store.dispatch('PicStore/getPicPedidos');
        }
      }
    },
    async handlePageChange(value) {
      this.$store.commit('SLSTabelapreco/SET_FILTERS', {
        ...this.$store.getters['SLSTabelapreco/filters'],
        page: value,
      });
      await this.getTabelaPrecoByClienteRRP();
    },

    async handleFiltersHeader(filteredItems) {
      Object.keys(this.filtersHeader).forEach((key) => {
        if (this.filtersHeader[key] === '') {
          delete this.filtersHeader[key];
        }
      });

      this.$store.commit('SLSTabelapreco/SET_FILTERS', {
        ...this.$store.getters['SLSTabelapreco/filters'],
        page: 1,
        ...this.filtersHeader,
      });

      await this.getTabelaPrecoByClienteRRP();
    },

    async resertFilterHeader() {
      this.filtersHeader = {
        tabelapreco_id: '',
        tabelapreco_descricao: '',
      };

      this.$store.commit('SLSTabelapreco/SET_FILTERS', {
        ...this.$store.getters['SLSTabelapreco/filters'],
        page: 1,
      });

      await this.getTabelaPrecoByClienteRRP();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-buscar-tabelapreco-info-pedido') {
        this.fetchInitialData();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
};
</script>

<template>
  <b-modal id="modal-buscar-tabelapreco-info-pedido" size="xl" ref="modalBuscarTabelapreco"
    title="Pesquisar Tabela de Preços" ok-only ok-title="FECHAR">
    <b-overlay variant="white" :show="$store.getters['SLSTabelapreco/loading'] || isLoading" spinner-variant="primary"
      blur="0" opacity=".75" rounded="sm">
      <b-row>
        <b-col cols="12" md="2">
          <b-form-group label="Cod Canal:" label-for="codTabelaPreco">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input id="codTabelaPreco" placeholder="Código" v-model="filtersHeader.tabelapreco_id" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <!-- Restante dos campos de formulário... -->
        <b-col cols="12" md="6">
          <b-form-group label="Descrição:" label-for="descTabelaPreco">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input id="descTabelaPreco" placeholder="Nome" v-model="filtersHeader.tabelapreco_descricao" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2" align-self="center">
          <b-row>
            <b-col cols="12" md="6">
              <b-button variant="success" @click="handleFiltersHeader">
                Filtrar
              </b-button>
            </b-col>
            <b-col cols="12" md="6">
              <b-button variant="danger" @click="resertFilterHeader">
                Limpar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12">
          <b-table striped hover responsive :current-page="currentPage" :items="tabelaPrecos" :fields="fields"
            show-empty empty-text="Nenhuma tabela encontrada">
            <template #cell(acoes)="data">
              <b-button size="sm" variant="primary" @click="info(data.item, data.index, $event.target)">
                Selecionar
              </b-button>
            </template>

            <template #cell(clienteDocumento)="data">
              {{ data.value | formatarDocumento }}
            </template>

            <template #cell(representanteativo)="data">
              <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                {{ data.value === 1 ? 'Ativo' : 'Inativo' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ dataMetaRepresentante }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="getTotalRows" :per-page="getPerPage"
                  @change="handlePageChange" first-number last-number align="center" class="my-0" />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<style scoped lang="scss"></style>
